import React, { useState, useEffect, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSelector } from "react-redux";
import { AuthContext } from "../../../Header/auth - context";
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import useVisinaTabele from "../../../custom/visinaTabele";

const BlagajnaPregled = () => {
  const { t } = useTranslation();

  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const company = useSelector(state => state.company);
  const user = useSelector(state => state.user)
  const [tableData, setTableData] = useState(null);
  const [allColumns, setAllColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [trenutniSaldo, setTrenutniSaldo] = useState([])
  const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  /* Spisak se zavrsava na dnu ekrana; visina se MERI, ne pogadja. */
  const [omotTabele, visinaTabele, redovaTabele] = useVisinaTabele([tableData]);

  // Path normalization and document location helper
  const getDocumentLocation = (path) => {
    if (!path) return null;
    
    // Normalize Windows path to URL format
    const normalizedPath = path.replace(/\\/g, '/');
    
    // Remove full C:/Dokumenta/ from path
    const relativePath = normalizedPath.replace(/^C:\/Dokumenta\//, '');
    const encodedPath = encodeURI(relativePath); // Encode spaces, etc.
    return `${process.env.REACT_APP_BACKEND_URL}/files/${encodedPath}`;
  };

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  useEffect(() => {

    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      }
    };
 
    fetch(process.env.REACT_APP_BACKEND_URL + `/finance`, requestOptions)
      .then(handleErrors)
      .then((data) => {
        const stringifiedJson = data[0][""];
        const parsedData = JSON.parse(stringifiedJson);
        setTableData(parsedData.SaldoDB)
        setTrenutniSaldo(parsedData.TrenutniStatus)
          // Extract all available columns from the first data row
            if (parsedData.SaldoDB && parsedData.SaldoDB.length > 0) {
        const columns = Object.keys(parsedData.SaldoDB[0])
            .filter(key => !['ID'].includes(key))
            .map(key => ({
            label: key,
            value: key
            }));
  
          
          setAllColumns(columns);
          const originalOrder = Object.keys(data[0]);
          setOriginalColumnOrder(originalOrder);
          
          // Select first 5 columns by default (or adjust as needed)
          setSelectedColumns(columns.slice(0, 5).map(col => col.value));
        }
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
  }, [auth.token, company.companyId]);


  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Blagajna');
  
      // Use selectedColumns instead of all table keys
      const headers = selectedColumns;
  
      // Add header row
      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      // Add filtered data rows
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      // Auto-size columns
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      // Serbian-formatted datetime
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Blagajna - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
       const header = (
          <div className="export-buttons fakture-stavke-header">
              <div className="fakture-stavke-radnje">
                <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
              </div>
            <input type="search" className="p-inputtext p-component"
                   onInput={(e) => setGlobalFilter(e.target.value)}
                   placeholder={t('nova.phPretraga')}
                   />
          </div>
      );

  return (
    <div className="zaposleni_table_container">
      <Toast ref={toast} />

      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1em" }}>
          <div style={{display:'flex'}}><p style={{marginRight: '10px',marginBottom: '0', display:'flex', justifyContent: 'center', alignItems:'center', minWidth:"fit-content"}}>Trenutni saldo:</p>{trenutniSaldo.map((item, i) => {
                            return (
                              <div key={i} style={{display:'flex', justifyContent: 'center', alignItems:'center', border: '1px solid rgb(224, 221, 221)', padding:'10px'}} >
                                <p style={{marginRight: '10px', marginBottom: '0',display:'flex', justifyContent: 'center', alignItems:'center'}} className={item.SumaKorigovana < 10 ? 'colorRed' : null}> <strong>{item.SumaKorigovana}</strong></p>
                                <p style={{marginRight: '10px', marginBottom: '0',display:'flex', justifyContent: 'center', alignItems:'center'}}><strong>[{item.Valuta}]</strong></p>
                              </div>
                            );
                          })}
            </div>
      </div>
      <Tooltip target=".export-buttons>button" position="bottom" />
      <div ref={omotTabele}>
      <DataTable className="stavke-tabela"
        value={tableData}
        paginator
        rows={redovaTabele}
        header={header}
        first={first}
        globalFilter={globalFilter}
        onPage={(e) => setFirst(e.first)}
        scrollable
        scrollHeight={visinaTabele}
        emptyMessage={t('common.noDataTable')}
        loading={tableData === null}
        resizableColumns
        columnResizeMode="expand"
      >

         {selectedColumns.map((colKey) => {
               const colMeta = allColumns.find(col => col.value === colKey);
               return (
                 <Column
                   key={colKey}
                   field={colKey}
                   header={colMeta?.label || colKey}
                   sortable
                   body={(rowData) => {
                     return rowData[colKey] || '-';
                   }}
                   style={{ minWidth: '150px' }}
                 />
               );
             })}
      </DataTable>
      </div>
    </div>
  );
};

export default BlagajnaPregled;